import { newE2EPage } from '@stencil/core/testing';

describe('jackery-upload', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-upload></jackery-upload>');

    const element = await page.find('jackery-upload');
    expect(element).toHaveClass('hydrated');
  });
});
